const TedDelIcon = () => (
  <div>
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 5.48177C16.1975 5.17927 13.1267 5.02344 10.065 5.02344C8.25 5.02344 6.435 5.1151 4.62 5.29844L2.75 5.48177"
        stroke="#2A60DF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.79199 4.55453L7.99366 3.3537C8.14033 2.48286 8.25033 1.83203 9.79949 1.83203H12.2012C13.7503 1.83203 13.8695 2.51953 14.007 3.36286L14.2087 4.55453"
        stroke="#2A60DF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.279 8.37891L16.6832 17.6097C16.5824 19.0489 16.4999 20.1672 13.9424 20.1672H8.05737C5.49987 20.1672 5.41737 19.0489 5.31654 17.6097L4.7207 8.37891"
        stroke="#2A60DF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.46875 15.125H12.5212"
        stroke="#2A60DF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.70801 11.457H13.2913"
        stroke="#2A60DF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
);
export default TedDelIcon;
